module.exports = __webpack_public_path__ + "static/media/Problem Solving (Introduction) V026.bb718e40.vtt";